Read<template>
    <!-- 英语优秀发音 -->
    <div
        class="read-box"
        v-if="(pageData.courseTypeId !== 13) && showModele && yxfyData && yxfyData.length"
    >
        <div :class="['title', 'title-en']">
            优秀发音
        </div>
        <div
            class="item"
            v-for="(item, index) in yxfyData"
            :key="index"
            v-show="item.isShow"
        >
            <div class="txt">
                {{item.txt}}
            </div>
            <div class="audio-box">
                <div class="audio-box_item">
                    <img
                        @click="handleClickPlayUrlBtn(item, index)"
                        class="img"
                        :src="item.isPlayUrl ? 'https://i.gsxcdn.com/2587843360_63bo5zr5.png' : 'https://i.gsxcdn.com/2587843359_3nn33xtg.png'"
                    >
                    <div class="desc">{{nickname}}</div>
                </div>
                <div class="audio-box_item">
                    <img
                        @click="handleClickPlayAudioBtn(item, index)"
                        class="img"
                        :src="item.isPlayAudio ? 'https://i.gsxcdn.com/2588000071_quh0f0oq.png' : 'https://i.gsxcdn.com/2588000062_03kcao60.png'"
                    >
                    <div class="desc">范读</div>
                </div>
            </div>
            <div class="star-box">
                <img class="star" v-for="(item) in item.stoneVal" :key="item" src="https://g.gsxcdn.com/2587842481_ns5yiinp.png" alt="">
            </div>
        </div>
        <div v-if="jiantouvisible" class="btn" @click="openAllFn">
            <div class="btn-name">
                {{isOpen ? '收起' : '展开'}}
            </div>
            <img
                class="icon"
                :src="[isOpen ? 'https://i.gsxcdn.com/2587887803_9bzcibqn.png' : 'https://i.gsxcdn.com/2587975585_84hfijc1.png']"
            >
        </div>
    </div>
</template>

<script lang="js">
import {Options, Vue} from 'vue-class-component';

@Options({
    components: {
    },
    mounted() {
    },
    props: {
        pageData: {
            type: Object,
            default() {
                return {};
            }
        },
        showModele: {
            type: Boolean,
            default() {
                return false;
            }
        }
    },
    computed: {
        yxfyData() {
            const {opusInfo} = this.pageData;
            opusInfo && opusInfo.length && opusInfo.forEach((item, index) => {
                item.isShow = index < 2;
                item.isPlayAudio = false;
                item.isPlayUrl = false;
            });
            const data = opusInfo || [];
            // 超出两个元素那么展示展开收起小箭头
            if (data.length > 2) {
                this.jiantouvisible = true;
            }
            return data;
        },
        nickname() {
            return this.pageData.nickname;
        }
    },
    watch: {
        showModele(val) {
            /**
             * 监听showModele来处理前后台切换，因为：
             * 将speech组件的v-if放在组件内部是要处理swiper组件的渲染问题，
             * 如果v-if放在外面的话speech组件会走完整的生命周期，导致swiper组件渲染失效，会有警告(Component is missing template or render function.)【未解】
             * 因此改变策略将v-if放在speech内部，那么speech的生命周期不会重新走，那么就要特殊处理语音播放问题
             */
            if (!val) {
                this.isPlayAudio = false;
                this.audioEl?.pause();
            }
        }
    },
})
export default class Speech extends Vue {
    // 音频节点
    audioEl = null;

    // 是否展示展开收起
    jiantouvisible = false;
    // 展开收起
    isOpen = false;

    // 点击展开收起
    openAllFn() {
        this.isOpen = !this.isOpen;
        this.yxfyData.forEach((item, index) => {
            item.isShow = this.isOpen ? true : index < 2;
        });
    }

    // 点击播放用户语音按钮
    handleClickPlayUrlBtn(item, index) {
        this.$emit('eventBus', 'yxfy');
        this.pauseAudio();

        this.yxfyData.forEach((item, i) => {
            item.isPlayAudio = false;
            if (i !== index) {
                item.isPlayUrl = false;
            }
        });
        item.isPlayUrl = !item.isPlayUrl;
        if (item.isPlayUrl) {
            this.playAudio(item.url).then(() => {
                item.isPlayUrl = false;
            });
        }
    }

    // 点击播放题干语音按钮
    handleClickPlayAudioBtn(item, index) {
        this.$emit('eventBus', 'yxfy');
        this.pauseAudio();

        this.yxfyData.forEach((item, i) => {
            item.isPlayUrl = false;
            if (i !== index) {
                item.isPlayAudio = false;
            }
        });
        item.isPlayAudio = !item.isPlayAudio;
        if (item.isPlayAudio) {
            this.playAudio(item.audio).then(() => {
                item.isPlayAudio = false;
            });
        }
    }

    // 暂停其他声音
    pauseAudio() {
        // 捕获是否有正在播放的视频，有的话全部停掉
        const allVideos = document.querySelectorAll('.oss-work-video');
        const arr = [...allVideos];
        arr.forEach(item => {
            item.pause();
        });
        this.audioEl && this.audioEl.pause();
    }

    resetAll() {
        this.pauseAudio();
        this.yxfyData.forEach((item, i) => {
            item.isPlayUrl = false;
            item.isPlayAudio = false;
        });
    }

    // 播放语音
    playAudio(url) {
        console.log(' ------ playAudio ------', url);
        // 播放语音
        return new Promise(resolve => {
            if (!url) {
                resolve();
            }
            if (!this.audioEl) {
                const audio = new Audio();
                audio.onabort = () => {
                    console.log(
                        JSON.stringify({
                            content: 'playAudio onabort',
                            audioUrl: url,
                        })
                    );
                    console.log(`playAudio onabort ${url}`);
                };
                audio.onwaiting = () => {
                    console.log(
                        JSON.stringify({
                            content: 'playAudio onwaiting',
                            audioUrl: url,
                        })
                    );
                    console.log(`playAudio onwaiting ${url}`);
                };
                this.audioEl = audio;
            }
            this.audioEl.src = url;
            this.audioEl.currentTime = 0;
            this.audioEl.load();
            this.audioEl.onended = () => {
                console.log('playAudio onended', url);
                resolve();
            };
            this.audioEl.onpause = () => {
                console.log('playAudio onpause', url);
                // resolve();
            };
            this.audioEl.onerror = error => {
                console.log(
                    JSON.stringify({
                        content: 'playAudio onerror',
                        audioUrl: url,
                        error: this.audioEl.error?.message,
                    })
                );
                console.log('playAudio onerror', url);
                console.log(this.audioEl.error?.message);
                resolve(error);
            };
            this.audioEl.play();
        });
    }
}
</script>

<style lang="scss" scoped>
.read-box {
    margin-top: 1.09rem;
    width: 9.15rem;
    background: #FFFFFF;
    box-shadow: 0 .05rem .21rem 0 rgba(229, 228, 228, .4);
    border-radius: .43rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .title {
        margin-top: -.28rem;
        margin-bottom: .67rem;
        display: flex;
        padding-top: .22rem;
        justify-content: center;
        font-size: .45rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        width: 4.53rem;
        height: 1.07rem;
        background: url('https://g.gsxcdn.com/2274041109_l17ijy0d.png') 0 no-repeat;
        background-size: cover;
        box-sizing: border-box;
    }

    .title-en {
        background: url('https://i.gsxcdn.com/2586791245_y04k2lo8.png') 0 no-repeat;
        background-size: cover;
    }

    .item {
        width: 8.43rem;
        height: 2.61rem;
        background: #FFFFFF;
        border-radius: .32rem;
        border: .03rem solid #EAFAF2;
        position: relative;
        padding: .32rem 0 0 .29rem;
        box-sizing: border-box;
        margin-bottom: .48rem;

        .txt {
            max-width: 5.97rem;
            word-wrap: break-word;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: .4rem;
            color: #0B0B0B;
            line-height: .51rem;
            margin-bottom: .13rem;
        }

        .audio-box {
            display: flex;
            align-items: center;
            position: absolute;
            bottom: .29rem;

            &_item {
                display: flex;
                align-items: center;
                width: 2.08rem;
                height: .85rem;
                background: #ECFEF6;
                border-radius: .43rem;
                margin-right: .32rem;

                .img {
                    width: .64rem;
                    height: .64rem;
                    margin-left: .11rem;
                    margin-right: .21rem;
                }

                .desc {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: .37rem;
                    color: #333333;
                }
            }
        }

        .star-box {
            position: absolute;
            top: .35rem;
            right: .32rem;

            .star {
                width: .52rem;
                height: .51rem;
            }
        }
    }

    .btn {
        display: flex;
        align-items: center;
        margin-bottom: .21rem;

        .btn-name {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: .32rem;
            color: #AEAEAE;
        }

        .icon {
            width: .43rem;
            height: .43rem;
        }
    }
}
</style>
